import styled from "styled-components/macro";

export const Card = styled.div`
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 4px 0 rgba(77, 80, 81, 0.12);
`;
